var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVolumeOff = function SvgIconVolumeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 33h9l7.758 7.759a4.243 4.243 0 0 0 7.242-3V10.243a4.242 4.242 0 0 0-7.242-3L13.5 15h-9A4.5 4.5 0 0 0 0 19.5v9A4.5 4.5 0 0 0 4.5 33",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.163 19.384A2.24 2.24 0 0 0 44.083 18c-.598 0-1.17.237-1.594.658l-2.817 2.808-2.82-2.808a2.26 2.26 0 0 0-3.676.728 2.24 2.24 0 0 0 .487 2.446l2.817 2.808-2.82 2.81a2.24 2.24 0 0 0 0 3.178 2.26 2.26 0 0 0 3.192 0l2.82-2.811 2.82 2.81a2.26 2.26 0 0 0 3.675-.728 2.24 2.24 0 0 0-.489-2.448l-2.82-2.811 2.817-2.811a2.24 2.24 0 0 0 .488-2.446"
  })));
};
export default SvgIconVolumeOff;